import * as yup from "yup"
import {
  getFieldMessages,
  fullNameField,
  phoneField,
  optionalEmailField,
  requiredTextField,
  optionalTextField,
  licensePlateField,
  timeField,
  requiredDateField,
  requiredFileField,
  optionalFilesField,
  checkboxField,
  IMAGE_MIME_TYPES,
  type FormLanguage,
} from "../../common/forms"

export const MAX_DAMAGE_PHOTOS = 6

export function createSchema(language: FormLanguage, checkboxRequired: boolean) {
  const m = getFieldMessages(language)

  return yup.object({
    fullName: fullNameField(m),
    phone: phoneField(m),
    email: optionalEmailField(m),
    incidentDate: requiredDateField(m),
    incidentTime: timeField(m),
    incidentLocation: requiredTextField(m),
    atFaultDriverName: optionalTextField(),
    atFaultLicensePlate: licensePlateField(m),
    thirdPartyLicensePlate: licensePlateField(m),
    incidentDescription: requiredTextField(m),
    // EGDE-340: the damage photos are optional (QA: this field should not be
    // mandatory). The vehicle-license photo below stays required.
    damagePhotos: optionalFilesField(
      IMAGE_MIME_TYPES,
      m.fileTypeImages,
      MAX_DAMAGE_PHOTOS,
    ),
    vehicleLicensePhoto: requiredFileField(
      m,
      IMAGE_MIME_TYPES,
      m.fileTypeImages,
    ),
    checkbox: checkboxField(m, checkboxRequired),
  })
}

export type FormValues = yup.InferType<ReturnType<typeof createSchema>>

export const defaultValues: FormValues = {
  fullName: "",
  phone: "",
  email: "",
  incidentDate: null as unknown as Date,
  incidentTime: "",
  incidentLocation: "",
  atFaultDriverName: "",
  atFaultLicensePlate: "",
  thirdPartyLicensePlate: "",
  incidentDescription: "",
  damagePhotos: [],
  vehicleLicensePhoto: undefined as unknown as File,
  checkbox: false,
}
